<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('订单编号')" prop="id">
                <a-input v-model="queryParam.id" @pressEnter="handleQuery" :maxLength="18" :placeholder="$t('请输入')+$t('订单编号')" allow-clear />
              </a-form-item>
            </a-col>
            <!--            <a-col :md="6" :sm="24">-->
            <!--              <a-form-item :label="$t('三方订单号')" prop="outTradeNo">-->
            <!--                <a-input v-model="queryParam.outTradeNo" @pressEnter="handleQuery" :maxLength="40" :placeholder="$t('请输入')+$t('三方订单号')" allow-clear />-->
            <!--              </a-form-item>-->
            <!--            </a-col>-->
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('订单状态')" prop="orderStatusList">
                <a-select mode="multiple" :placeholder="$t('请选择')+$t('订单状态')"
                          @change="orderStatusListChange"
                          style="width: 100%" v-model="queryParam.orderStatusList" allowClear>
                  <a-select-option v-for="(item, index) in this.customDict.OrderSellStatusEnum" :value="item.type"
                                   :key="index">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('退款状态')" prop="orderStatusList">
                  <a-select mode="multiple" :placeholder="$t('请选择')+$t('退款状态')"
                            style="width: 100%" v-model="queryParam.refundStatusList" allowClear>
                    <a-select-option v-for="(item, index) in this.customDict.OrderRefundStatusEnum" :value="item.type"
                                     :key="index">
                      {{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('买家ID')" prop="buyerName">
                  <a-input v-model="queryParam.buyerId" @pressEnter="handleQuery" :maxLength="20" :placeholder="$t('请输入')+$t('买家ID')" allow-clear />
                </a-form-item>
              </a-col>
              <template v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('买家名称')" prop="buyerName">
                  <a-input v-model="queryParam.buyerName" @pressEnter="handleQuery" :maxLength="20" :placeholder="$t('请输入')+$t('买家名称')" allow-clear />
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('买家信息')" prop="userMobile">
                  <a-input v-model="queryParam.userMobile" @pressEnter="handleQuery" :maxLength="20" :placeholder="$t('请输入')+$t('手机号或邮箱')" allow-clear />
                </a-form-item>
              </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('备注')" prop="adminRemark">
                <a-input v-model="queryParam.adminRemark" @pressEnter="handleQuery" :maxLength="20" :placeholder="$t('请输入')+$t('备注')" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('国家')" prop="nation">
                <a-select  :placeholder="$t('请选择')+$t('国家')"
                           show-search
                           :filter-option="nationFilter"
                           style="width: 100%" v-model="queryParam.nation" allowClear>
                  <a-select-option v-for="(item, index) in nationOptions" :value="item.type" :key="index">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('商品分类')" prop="categoryId">
                  <a-tree-select v-model="queryParam.categoryId" style="width: 100%"
                                 :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" :tree-data="cateOptions" :placeholder="$t('请选择')+$t('商品分类')"
                                 :replaceFields="{ children: 'children', title: 'categoryName', key: 'id', value: 'id' }"
                                 tree-default-expand-all allow-clear>
                  </a-tree-select>
                </a-form-item>
              </a-col>
              <a-col :md="6">
                <a-form-item prop="goodsId" :label="$t('商品编号')">
                  <a-input v-model="queryParam.goodsId" @pressEnter="handleQuery" :maxLength="100" placeholder="" allow-clear />
                </a-form-item>
              </a-col>
              <a-col :md="6">
                <a-form-item prop="goodsSku" :label="$t('SKU编码')">
                  <a-input v-model="queryParam.goodsSku" @pressEnter="handleQuery" :maxLength="64" :placeholder="$t('请输入')+$t('SKU编码')" allow-clear />
                </a-form-item>
              </a-col>
              <a-col :md="12" :sm="24">
                <a-form-item prop="goodsName">
                    <span slot="label">
                      <a-tooltip>
                        {{ $t('商品名称') }}
                        <template slot="title">
                          {{$t('关键词提示')}}
                        </template>
                      </a-tooltip>
                    </span>
                  <a-input v-model="queryParam.goodsName" @pressEnter="handleQuery" :maxLength="100" :placeholder="$t('关键词提示')" allow-clear />
                </a-form-item>
              </a-col>

              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('支付方式')" prop="payTypeList">
                  <a-select mode="multiple" :placeholder="$t('请选择')+$t('支付方式')"
                            style="width: 100%" v-model="queryParam.payTypeList" allowClear>
                    <a-select-option v-for="(item, index) in this.customDict.PayTypeEnum" :value="item.type"
                                     :key="index">
                      {{ $t(item.name) }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('是否催发货')" prop="isRemind">
                  <a-select :placeholder="$t('请选择')+$t('是否催发货')"
                            style="width: 100%" v-model="queryParam.isRemind" allowClear>
                    <a-select-option v-for="(item, index) in this.customDict.TFEnum" :value="item.type"
                                     :key="index">
                      {{ $t(item.name) }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('下单开始时间')" prop="createBeginTime">
                  <a-date-picker style="width: 100%" v-model="queryParam.createBeginTime"
                                 :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}"
                                 valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear />
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('下单结束时间')" prop="createEndTime">
                  <a-date-picker style="width: 100%" v-model="queryParam.createEndTime"
                                 :show-time="{defaultValue: moment('23:59:59', 'HH:mm:ss')}"
                                 valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear />
                </a-form-item>
              </a-col>
              </template>
            <a-col :md="!advanced && 6 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('查询') }}</a-button>
                <!--                <a-button style="margin-left: 8px" type="primary" @click="$refs.unitCount.handleUnitCount(queryParam)"><a-icon type="search" />单位订单量</a-button>-->
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('重置') }}</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? $t('收起') : $t('展开') }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
        <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
          <img alt="example" style="width: 100%" :src="previewUrl" />
        </a-modal>
      </div>
      <a-tabs v-model="activeKey" @tabClick="changeTab">
        <a-tab-pane key="" :tab=" $t('全部订单')" />
        <a-tab-pane v-for="pane in this.customDict.OrderSellStatusEnum" :key="pane.type" :tab="$t(pane.name)">
        </a-tab-pane>
      </a-tabs>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="handleExport" v-hasPermi="['order:sell:export']">
          <a-icon type="download" />
          {{ $t('导出') }}
        </a-button>
        <a-button type="primary" :disabled="multiple" @click="handleSelectExport" v-hasPermi="['order:sell:export']">
          <a-icon type="download" />
          {{ $t('选中导出') }}
        </a-button>
        <a-button type="primary" @click="handleDeliveryExport" v-hasPermi="['order:sell:export']">
          <a-icon type="download" />
          {{ $t('导出待发货') }}
        </a-button>
        <a-button type="dashed" @click="$refs.importExcel.importExcelHandleOpen()"
                  v-hasPermi="['order:sell:delivery']">
          <a-icon type="import" />
          {{ $t('导入发货单') }}
        </a-button>
<!--        <a-button type="primary" @click="handleGoodsExport" v-hasPermi="['order:sell:export']">
          <a-icon type="download" />
          {{ $t('订单商品导出') }}
        </a-button>-->
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <detail-form
        ref="detailForm"
        @ok="getList"
      />
      <delivery-form
        ref="deliveryForm"
        @ok="getList"
      />
      <lock-time-form
        ref="lockTimeForm"
        @ok="getList"
      />
      <batch-lock-time-form
        ref="batchLockTimeForm"
        @ok="getList"
      />
      <logistic-detail
        ref="logisticDetail"
      />
      <unit-count
        ref="unitCount"
      />
      <import-excel ref="importExcel" @ok="getList" />

      <!-- 数据展示 -->
      <a-table
        :scroll="{ x: '140%', y: tableScrollY }"
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="payTime" slot-scope="text, record">
          {{ parseTime(record.payTime) }}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="id" slot-scope="text, record">
          <a @click="$refs.detailForm.handleDetail(record.id)">{{ record.id }}</a>
        </span>
        <span slot="orderStatus" slot-scope="text, record">
            <!-- 重写自定义了个字典组件-->
           <custom-dict-tag :options="customDict.OrderSellStatusEnum" :value="record.orderStatus" />
        </span>
        <span slot="isFirstOrder" slot-scope="text, record">
           <custom-dict-tag :options="customDict.TFEnum" :value="record.isFirstOrder" />
        </span>
        <span slot="isRemind" slot-scope="text, record">
           <custom-dict-tag :options="customDict.TFEnum" :value="record.isRemind" />
        </span>
        <div slot="goodsTitle" style="width: 350px">
          <a-row>
            {{ $t('商品信息') }}
          </a-row>
          <a-row>
            <a-col :span="13">{{ $t('skuCode') }}</a-col>
            <a-col :span="3">{{$t('图片')}}</a-col>
            <a-col :span="3">{{ $t('数量') }}</a-col>
          </a-row>
        </div>
        <div slot="orderItemList" slot-scope="text, record">
          <a-table :showHeader="false" size="small" :bordered="false" rowKey="skuId"
                   :pagination="false" :columns="goodsColumns" :data-source="record.orderItemList">
            <template slot="picture" slot-scope="text, record">
              <div>
                <img v-if="record.picture" :src="record.picture"  style="width:40px;height:40px;" @click="handleRecordPreview(record.picture)" alt="none"/>
              </div>
            </template>
          </a-table>
        </div>
        <span slot="logisticsNo" slot-scope="text, record">
           <template v-if="record.isError">
            <span>{{ record.adminRemark }}</span>
           </template>
          <template v-else-if="record.logisticsNo">
            <template v-for="(logisticNo, index) in record.logisticsNo.split(',')">
<!--              <a @click="$refs.logisticDetail.handleDetailByNo(logisticNo.trim())">{{ logisticNo.trim() }}</a>-->
              <a @click="openLogistics(logisticNo.trim())">{{ logisticNo.trim() }}</a>
              <span v-if="index < record.logisticsNo.split(',').length - 1">, </span>
            </template>
          </template>
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.detailForm.handleDetail(record.id)">
            <a-icon type="eye" />{{ $t('详情') }}
          </a>
         <template v-if="record.orderStatus===2015">
            <a-divider type="vertical" />
              <a @click="handleOrders(record.id)" v-hasPermi="['order:sell:orders']">
              <a-icon type="audit" />{{ $t('接单') }}
            </a>
         </template>

         <template v-if="record.orderStatus===2010">
              <a-divider type="vertical" />
             <a @click="handleCancel(record)" v-hasPermi="['order:sell:cancel']">
                <a-icon type="edit" />{{ $t('取消订单') }}
              </a>
        </template>

           <template v-if="record.orderStatus===2020|| record.orderStatus===2025">
                <a-divider type="vertical" />
               <a @click="$refs.deliveryForm.handleDelivery(record.id)" v-hasPermi="['order:sell:delivery']">
                  <a-icon type="edit" />{{ $t('发货') }}
                </a>
          </template>
          <template v-if="record.orderStatus===2030|| record.orderStatus===2050">
                <a-divider type="vertical" />
                <a @click="$refs.logisticDetail.handleDetail(record.id)">
                  <a-icon type="environment" />{{ $t('物流详情') }}
                </a>
          </template>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageSell, idCardSell, ordersSell, cancelSell } from '@/api/order/sell'

import CustomDictTag from '@/components/DictCustomTag'
import { mapGetters } from 'vuex'
import moment from 'moment'
import LogisticDetail from './modules/LogisticDetail'
import ImportExcel from './modules/ImportExcel'
import detailForm from './modules/detailForm'
import { tableMixin } from '@/store/table-mixin'
import DeliveryForm from '@/views/order/sell/modules/DeliveryForm'
import { listCategory } from '@/api/goods/category'
import LockTimeForm from '@/views/order/sell/modules/LockTimeForm'
import BatchLockTimeForm from './modules/BatchLockTimeForm'
import UnitCount from './modules/UnitCount.vue'

export default {
  name: 'Sell',
  components: {
    DeliveryForm,
    CustomDictTag,
    ImportExcel,
    detailForm,
    LogisticDetail,
    LockTimeForm,
    BatchLockTimeForm,
    UnitCount
  },
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      cateOptions: [],
      starList: [],
      activeKey: null,
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo: {},
      selectedRowKeys: [],
      selectedRows: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        id: undefined,
        buyerId: undefined,
        nation: undefined,
        starId: undefined,
        shareUserId: undefined,
        goodsId: undefined,
        goodsSku: undefined,
        categoryId: undefined,
        goodsName: undefined,
        isPay: undefined,
        outTradeNo: undefined,
        buyerName: undefined,
        createBeginTime: undefined,
        createEndTime: undefined,
        payType: undefined,
        payTime: undefined,
        userMobile: undefined,
        orderStatus: undefined,
        orderStatusList: undefined,
        refundStatusList: undefined,
        payTypeList: undefined,
        refundStatus: undefined,
        isFirstOrder: undefined,
        isRemind: undefined,
        isError: undefined,
        saleEndDate: undefined,
        saleEndTime: undefined,
        errorUpdateTimeStart: undefined,
        errorUpdateTimeEnd: undefined,
        adminRemark: undefined,
        idCardStatus: undefined,
        pageNum: 1,
        pageSize: 10
      },


      goodsColumns:[
        {
          dataIndex: 'skuCode',
          width:150,
          align: 'center',
        },
        {
          dataIndex: 'picture',
          width:50,
          scopedSlots: {customRender: 'picture'},
          align: 'center'
        },
        {
          width:50,
          dataIndex: 'goodsCount',
          align: 'center'
        },
      ],

      columns: [
        {
          title: this.$t('订单编号'),
          dataIndex: 'id',
          scopedSlots: { customRender: 'id' },
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          align: 'center',
          width: '120px',
          fixed: 'left'
        },
        {
          title: this.$t('订单状态'),
          dataIndex: 'orderStatusName',
          width: '80px',
          fixed: 'left',
          align: 'center'
        },
        {
          title: this.$t('下单时间'),
          dataIndex: 'createTime',
          sorter: 1,
          width: '160px',
          sortDirections: ['descend', 'ascend'],
          scopedSlots: { customRender: 'createTime' },
          align: 'center'
        },
        {
          title: this.$t('买家名称'),
          dataIndex: 'buyerName',
          width: '120px',
          align: 'center'
        },
        {
          title: this.$t('下单总数'),
          dataIndex: 'buyerOrderCount',
          width: '80px',
          align: 'center'
        },
        {
          title: this.$t('商品数量'),
          sorter: 1,
          width: '80px',
          sortDirections: ['descend', 'ascend'],
          dataIndex: 'goodsCount',
          align: 'center'
        },
        {
          title: this.$t('商品名称'),
          width: '180px',
          dataIndex: 'goodsName',
          align: 'center'
        },
        {
          width: '280px',
          dataIndex: 'orderItemList',
          scopedSlots: { customRender: 'orderItemList' },
          slots: { title: 'goodsTitle' },
          align: 'center'
        },
        {
          title: this.$t('实付金额'),
          sorter: 1,
          width: '100px',
          sortDirections: ['descend', 'ascend'],
          dataIndex: 'payAmount',
          align: 'center'
        },
        {
          title: this.$t('运费'),
          width: '80px',
          dataIndex: 'shippingPayAmount',
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          align: 'center'
        },
        {
          title: this.$t('国家'),
          dataIndex: 'nationName',
          width: '100px',
          align: 'center'
        },
        {
          title: this.$t('支付方式'),
          dataIndex: 'payTypeName',
          width: '100px',
          align: 'center'
        },
        {
          title: this.$t('支付时间'),
          dataIndex: 'payTime',
          sorter: 1,
          width: '160px',
          sortDirections: ['descend', 'ascend'],
          scopedSlots: { customRender: 'payTime' },
          align: 'center'
        },
        {
          title: this.$t('三方订单号'),
          dataIndex: 'outTradeNo',
          width: '150px',
          align: 'center'
        },
        {
          title: this.$t('退款状态'),
          dataIndex: 'refundStatusName',
          width: '80px',
          align: 'center'
        },
        {
          title: this.$t('是否催发货'),
          sorter: 1,
          width: '80px',
          sortDirections: ['descend', 'ascend'],
          scopedSlots: { customRender: 'isRemind' },
          dataIndex: 'isRemind',
          align: 'center'
        },
        {
          title: this.$t('备注'),
          dataIndex: 'adminRemark',
          width: '120px',
          align: 'center'
        },
        {
          title: this.$t('操作'),
          dataIndex: 'operation',
          fixed: 'right',
          width: '150px',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {},
  created() {
    this.getCategoryList()
    this.getOrderRouteList()
  },
  watch: {
    $route: 'getOrderRouteList'
  },
  mounted() {
  },
  computed: {
    ...mapGetters(['customDict']),
    nationOptions() {
      const list = (this.customDict && this.customDict.UserNationEnum) || []
      const map = new Map()
      list.forEach(item => {
        if (!map.has(item.type)) {
          map.set(item.type, item)
        }
      })
      return Array.from(map.values())
    }
  },
  methods: {
    moment,
    getTotal(total) {
      return this.$t('共') + total + this.$t('条')
    },
    getOrderRouteList() {
      let params = this.$route.params
      if (params.buyerId) {
        this.queryParam.buyerId = params.buyerId
        this.queryParam.isPay = params.isPay
      }
      if (params.id) {
        this.queryParam.id = params.id
      }
      if (params.shareUserId) {
        this.queryParam.shareUserId = params.shareUserId
      }
      this.getList()
    },
    /** 查询销售订单列表 */
    getList() {
      this.loading = true
      pageSell(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    orderStatusListChange() {
      this.queryParam.orderStatus = undefined
    },
    //切换tab
    changeTab(index) {
      if (index == null) {
        index = undefined
      }
      this.queryParam.orderStatus = index
      this.getList()
    },
    onStarSelect(value) {
      this.queryParam.starId = value
    },
    handleStarSearch(value) {
      if (value === undefined) {
        return
      }
      if (value === '') {
        return
      }
      listStar({ 'starName': value }).then(response => {
        this.starList = response.data
      })
    },
    handleStarChange(value) {
      this.queryParam.starId = value
      //getStarList(value, data => (this.starList = data));
    },

    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    handleQueryUnit() {
      this.queryParam.pageNum = 1
      this.getList()
    },

    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        id: undefined,
        buyerId: undefined,
        nation: undefined,
        starId: undefined,
        goodsId: undefined,
        goodsSku: undefined,
        shareUserId: undefined,
        categoryId: undefined,
        goodsName: undefined,
        isPay: undefined,
        outTradeNo: undefined,
        buyerName: undefined,
        orderStatusList: undefined,
        refundStatusList: undefined,
        createBeginTime: undefined,
        createEndTime: undefined,
        payType: undefined,
        payTypeList: undefined,
        payTime: undefined,
        userMobile: undefined,
        orderStatus: undefined,
        refundStatus: undefined,
        isFirstOrder: undefined,
        isRemind: undefined,
        isError: undefined,
        saleEndDate: undefined,
        saleEndTime: undefined,
        errorUpdateTimeStart: undefined,
        errorUpdateTimeEnd: undefined,
        adminRemark: undefined,
        idCardStatus: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = ''
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    nationFilter(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    /*页面初始化时获取分类类别*/
    getCategoryList() {
      listCategory().then(response => {
        this.categoryList = response.data
        let children = this.handleTree(response.data, 'id', 'pid')
        console.log('children', children)
        this.cateOptions = children
      })
    },

    openLogistics(no) {
      const href = 'https://www.kuaidi100.com/chaxun?com=&nu=' + no
      window.open(href, '_blank')
    },
    handleOrders(record) {
      ordersSell({ id: record.id })
        .then(() => {
          this.onSelectChange([], [])
          this.getList()
          const message = this.$t('接单成功')
          this.$message.success(
            message,
            3
          )
        })
    },

    handleCancel(record) {
      var that = this
      this.$confirm({
        title: this.$t('确认取消'),
        onOk() {
          return cancelSell({ id: record.id })
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              const message = that.$t('取消成功')
              that.$message.success(
                message,
                3
              )
            })
        },
        onCancel() {
        }
      })
      this.getList()
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: this.$t('是否确认导出'),
        content: this.$t('此操作将导出当前条件下所有数据而非选中数据'),
        onOk() {
          that.download('order/sell/export',
            that.queryParam
            , `销售订单_${new Date().getTime()}.xlsx`)
        },
        onCancel() {
        }
      })
    },

    handleSelectExport() {
      var that = this
      let queryParam = { 'idList': this.ids }
      this.$confirm({
        title: this.$t('是否确认导出'),
        content: this.$t('此操作将导出选中数据'),
        onOk() {
          that.download('order/sell/export', queryParam, `销售订单_${new Date().getTime()}.xlsx`)
          that.ids = []
          that.multiple = true
          that.selectedRowKeys = []
        },
        onCancel() {
          that.ids = []
          that.multiple = true
          that.selectedRowKeys = []
        }
      })
    },

    handleDeliveryExport() {
      var that = this
      let queryForm = {
        id: this.queryParam.id,
        nation: this.queryParam.nation,
        starId: this.queryParam.starId,
        idList: this.ids,
        goodsId: this.queryParam.goodsId,
        goodsName: this.queryParam.goodsName,
        createBeginTime: this.queryParam.createBeginTime,
        createEndTime: this.queryParam.createEndTime,
        isRemind: this.queryParam.isRemind,
        isError: this.queryParam.isError,
        errorUpdateTimeStart: this.queryParam.errorUpdateTimeStart,
        errorUpdateTimeEnd: this.queryParam.errorUpdateTimeEnd,
        saleEndDate: this.queryParam.saleEndDate,
        saleEndTime: this.queryParam.saleEndTime
      }

      this.$confirm({
        title: this.$t('是否确认导出'),
        content: this.$t('此操作将导出当所有待发货订单而非选中数据'),
        onOk() {
          that.download('order/sell/delivery/export', queryForm, `发货清单_${new Date().getTime()}.zip`)

        },
        onCancel() {
        }
      })
      this.ids = []
      this.multiple = true
      this.selectedRowKeys = []
    },
    handleIdCardStatus() {
      var that = this
      let idList = this.ids
      this.$confirm({
        title: '修改状态',
        content: '这些订单将被提醒要上传身份证',
        onOk() {
          return idCardSell({ idList: idList })
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              const message = '通知成功'
              that.$message.success(message, 3)
            })
        },
        onCancel() {
        }
      })
      this.ids = []
      this.multiple = true
      this.selectedRowKeys = []
    },
    handleGoodsExport() {
      var that = this
      let queryForm = this.queryParam
      queryForm.idList = this.ids
      this.$confirm({
        title: this.$t('是否确认导出'),
        onOk() {
          that.download('order/sell/goods/export', queryForm, `商品订单_${new Date().getTime()}.zip`)

        },
        onCancel() {
        }
      })
      this.ids = []
      this.multiple = true
      this.selectedRowKeys = []
    }
  }
}
</script>
<style>
.innerTable > .ant-card-body {
  padding: 0px;
}
</style>
